import React from 'react'
import { Field, ErrorMessage, getIn } from 'formik'
import ErrorPopUp from '../../Shared/ErrorPopUp'
import { AsyncCategorySelect } from '../../Shared/AsyncCategorySelect'
import AsyncBrandSelect from '../../Shared/AsyncBrandSelect'
import NumberFormat from 'react-number-format'
import MeasurementTypeSelect from '../../Shared/MeasurementTypeSelect'

String.prototype.replaceAt = function(index, replacement) {
  return (
    this.substr(0, index) +
    replacement +
    this.substr(index + replacement.length)
  )
}

export default ({
  touched,
  errors,
  setFieldValue,
  values,
  handleBlur,
  categoryType,
  initialData
}) => (
  <fieldset className="fieldset blue-fieldset">
    <legend>کالای نهایی (انبار محصولات)</legend>
    <div className="row">
      <div className="form-inline">
        <div className="col-md-6">
          <label>نام کالا</label>
          <Field
            type="text"
            value={values.name}
            onBlur={handleBlur}
            name="name"
            autoFocus
            onChange={e => {
              let val = e.target.value
              // let code = val.match(/\d+/g)
              setFieldValue('name', val)
              setFieldValue(
                `items[0][name]`,
                val.replace(initialData.name, initialData.items[0].name)
              )
              setFieldValue(
                `items[1][name]`,
                val.replace(initialData.name, initialData.items[1].name)
              )
              setFieldValue(
                `items[2][name]`,
                val.replace(initialData.name, initialData.items[2].name)
              )
              setFieldValue(
                `items[5][name]`,
                val.replace(initialData.name, initialData.items[5].name)
              )
              // setFieldValue(`items[1][name]`, initialData.items[1].name + code)
              // setFieldValue(`items[2][name]`, initialData.items[2].name + code)
            }}
            className={
              getIn(errors, 'name') ? 'text-input has-error' : 'text-input'
            }
          />
          {/* <ErrorMessage component={ErrorPopUp} name="name" /> */}
        </div>

        <div className="col-md-2">
          <label>کد کالا</label>
          <Field
            type="text"
            value={values.extraCode}
            name="extraCode"
            onChange={e => {
              let val = e.target.value
              setFieldValue('extraCode', val)
              setFieldValue(`items[0][extraCode]`, val.replaceAt(0, '4'))
              setFieldValue(`items[1][extraCode]`, val.replaceAt(0, '2'))
              setFieldValue(`items[2][extraCode]`, val.replaceAt(0, '6'))
              setFieldValue(`items[5][extraCode]`, val.replaceAt(0, '5'))
              let shortExtraCode = ''
              // if (val.length === 15 && val.toString().includes('-')) {
              //   shortExtraCode = val
              //     .replaceAll('-', '')
              //     .substr(val.length - 8, 4)
              // }
              const hyphenCount = val.split('-').length - 1
              if (hyphenCount === 2) {
                const parts = val.split('-')
                shortExtraCode = parts[1]
              }
              setFieldValue('shortExtraCode', shortExtraCode)
              setFieldValue(`items[0][shortExtraCode]`, shortExtraCode)
              setFieldValue(`items[1][shortExtraCode]`, shortExtraCode)
              setFieldValue(`items[2][shortExtraCode]`, shortExtraCode)
              setFieldValue(`items[5][shortExtraCode]`, shortExtraCode)
              setFieldValue(`items[3][shortExtraCode]`, shortExtraCode)
            }}
            onBlur={handleBlur}
            className={
              getIn(errors, 'extraCode')
                ? 'text-input bold has-error'
                : 'text-input bold'
            }
          />
          {/* <ErrorMessage component={ErrorPopUp} name="extraCode" /> */}
        </div>

        <div className="col-md-2">
          <label>کد کوتاه کالا</label>
          <NumberFormat
            isNumericString
            allowNegative={false}
            defaultValue={values.shortExtraCode}
            value={values.shortExtraCode}
            name="shortExtraCode"
            onChange={e => {
              setFieldValue('shortExtraCode', e.target.value)
              setFieldValue(`items[0][shortExtraCode]`, e.target.value)
              setFieldValue(`items[1][shortExtraCode]`, e.target.value)
              setFieldValue(`items[2][shortExtraCode]`, e.target.value)
              setFieldValue(`items[5][shortExtraCode]`, e.target.value)
              setFieldValue(`items[3][shortExtraCode]`, e.target.value)
            }}
            onBlur={handleBlur}
            className={
              getIn(errors, 'shortExtraCode')
                ? 'text-input has-error'
                : 'text-input'
            }
          />
          {/* <ErrorMessage component={ErrorPopUp} name="shortExtraCode" /> */}
        </div>

        <div className="col-md-2 col-sm-4">
          <label>ضریب تبدیل</label>
          <NumberFormat
            isNumericString
            allowNegative={false}
            defaultValue={values.conversionUnit}
            value={values.conversionUnit}
            name="conversionUnit"
            onChange={e => {
              setFieldValue('conversionUnit', e.target.value)
              setFieldValue(`items[0][conversionUnit]`, e.target.value)
              // setFieldValue(`items[5][conversionUnit]`, e.target.value)
            }}
            onBlur={handleBlur}
            className={
              getIn(errors, 'conversionUnit')
                ? 'text-input has-error'
                : 'text-input'
            }
          />
          {/* <ErrorMessage component={ErrorPopUp} name="conversionUnit" /> */}
        </div>

        <div className="clearfix" />

        <div className="col-md-3">
          <label>دسته بندی</label>
          <AsyncCategorySelect
            onlyMainClass={true}
            categoryType={categoryType}
            defaultValue={values.categoryId}
            name="categoryId"
            onChange={(val, measurementType) => {
              // console.log(val);
              setFieldValue('categoryId', val)
              // setFieldValue('measurementType', measurementType)
            }}
            className={
              getIn(errors, 'categoryId')
                ? 'semantic-select-box has-error'
                : 'semantic-select-box'
            }
          />
          {/* <ErrorMessage component={ErrorPopUp} name="categoryId" /> */}
        </div>

        <div className="col-md-3">
          <label>برند</label>
          <AsyncBrandSelect
            brandType={categoryType === 0 ? 0 : 1}
            defaultValue={values.brandId}
            name="brandId"
            onChange={val => {
              // console.log(val);

              setFieldValue('brandId', val)

              let items = values.items
              items.forEach(item => {
                if (item.index !== 4 && item.index !== 6) {
                  item['brandId'] = val
                }
              })
              setFieldValue('items', items)
            }}
            className={
              getIn(errors, 'brandId')
                ? 'semantic-select-box has-error'
                : 'semantic-select-box'
            }
          />
          {/* <ErrorMessage component={ErrorPopUp} name="brandId" /> */}
        </div>

        {/* <div className="col-md-2 col-sm-4">
          <label>واحد اصلی</label>
          <MeasurementTypeSelect
            defaultValue={values && values.measurementType}
            onChange={val => {
              setFieldValue("measurementType", val)
            }}
            className="text-input required rtl"
          />
          <ErrorMessage component={ErrorPopUp} name="measurementType" />
        </div>

        <div className="col-md-2 col-sm-4">
          <label>واحد فرعی</label>
          <MeasurementTypeSelect
            defaultValue={values && values.subMeasurementType}
            onChange={val => {
              setFieldValue("subMeasurementType", val)
            }}
            className="text-input required rtl"
          />
          <ErrorMessage component={ErrorPopUp} name="subMeasurementType" />
        </div> */}

        {/* <div className="clearfix"></div>

        <div className="col-md-6">
          <label>توضیحات</label>
          <Field type="text"
            value={values.description}
            onBlur={handleBlur}
            name="description"
            // autoFocus
            className="text-input"
          />
          // <ErrorMessage component={ErrorPopUp} name="description" />
        </div> */}
      </div>
    </div>
  </fieldset>
)
